.ad-top {
  align-self: flex-start;
  position: relative;

  &__label {
    color: #999;
    font: use-font('400 10px/16px');
  }

  &__wrapper {
    color: inherit;
    height: 34px;
    position: relative;
    text-decoration: none;
  }

  &__image {
    display: block;
    height: 34px;
    max-width: 100%;
    object-fit: contain;
  }

  &__impression {
    bottom: 0;
    position: absolute;
    right: 0;
  }
}
